module.exports = __webpack_public_path__ + "img/csv.6f24adca.svg";